import { localized } from "@msuite/utils/locales";
import type { PropsWithChildren } from "react";
import { BlankSlateInline } from "../blank-slate";
import { Spinner } from "../spinner";
import type { ClassNameProps } from "../types";
import { cn } from "../utils";

/** Props Interface */
interface LoadingProps extends PropsWithChildren, ClassNameProps {
	isLoading: boolean;
	label?: string;
}

export function Loading({
	isLoading,
	children,
	className,
	label = localized("general.loading"),
}: LoadingProps) {
	/** If not loading, return children */
	if (!isLoading) return children;

	/** Render */
	return (
		<div className={cn(className)}>
			<BlankSlateInline
				Icon={() => <Spinner />}
				label={label}
			/>
		</div>
	);
}
